import { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { jsx } from 'react/jsx-runtime';
import { r as useBasketCount, v as useBasketUrl, w as useLocation, x as useRefreshBasketCount } from './index-905103ef.js';
import { c as MastheadLink } from './NavLink-4dd1029a.js';
import '@ux/accounts-client';
import '@ux/whitelabel';
import '@ux/auth';
import 'react-query';
import '@uds/cookies';
import '@ux/drivers';
import 'jwt-decode';
import '@ux/language';
import '@uds/tagmg';
import '@ux/bus';
import '@uds/grid';
import '@uds/colorway';
import './footer.stylesheet_1cai24r.css';
import '@uds/message';
import './footerlogo.stylesheet_1nwsfvw.css';
import '@uds/link';
import './footerlinks.stylesheet_1tdonhv.css';
import 'linaria';
import '@uds/typography';
import './footerlinkgroup.stylesheet_1k80bmr.css';
import './footerlink.stylesheet_1la25ae.css';
import './footerlegallinks.stylesheet_11hu4qw.css';
import '@uds/glyphs';
import '@uds/theme-utils';
import './footersocial.stylesheet_1vs2jgr.css';
import '@uds/padding-box';
import './footercopyright.stylesheet_1vs80r0.css';
import '@artsy/fresnel';
import '@ux/currency';
import '@uds/currency-symbol';
import './currency.stylesheet_1ps9h4b.css';
import '@uds/hooks';
import 'is-uuid';
import '@uds/flag';
import './languagelabel.stylesheet_1bydy.css';
import './picker.stylesheet_1sdqf0u.css';
import './mastheadpopoutbutton.stylesheet_1ta9x9o.css';
import './mastheadlink.stylesheet_1pwh77h.css';
import './popout.stylesheet_yym5ms.css';
import './popoutlink.stylesheet_1a3xsog.css';
import './userdetails.stylesheet_19hsuiq.css';
import '@uds/badge';
import './navlink.stylesheet_dtzwwk.css';

const BasketBanner = _ref => {
  let {
    isEcommerce,
    label,
    classname,
    glyph,
    glyphAlign
  } = _ref;
  const intl = useIntl();
  const {
    data: basketItemCount
  } = useBasketCount();
  const basketUrl = useBasketUrl();
  const location = useLocation();
  const refresh = useRefreshBasketCount();
  useEffect(() => {
    if (isEcommerce) {
      refresh();
    }
  }, [location, refresh, isEcommerce]);
  return /*#__PURE__*/jsx(MastheadLink
  // @todo fix this - only way it re-renders on lang change
  , {
    id: "bks-basket",
    classname: classname,
    href: basketItemCount > 0 ? basketUrl : undefined,
    label: label,
    values: {
      count: basketItemCount
    },
    glyph: {
      icon: 'cart',
      ...glyph
    },
    glyphAlign: glyphAlign
  }, `basket_${intl.locale}`);
};
BasketBanner.displayName = 'BasketBanner';

export { BasketBanner as default };
